import React, { useEffect, useState } from "react";
import { Container } from "react-bootstrap";
import { getContentPage } from "store/actions";
import { useSelector, useDispatch } from "react-redux";

export default function Serviceagreement() {
  const dispatch = useDispatch();

  const { content } = useSelector((state) => state?.contentpage);

  useEffect(() => {
    dispatch(getContentPage());
  }, []);

  const getContent = () =>{
    return content?.length && content?.find((item)=> item?.slug === "platform-as-a-service-agreement")?.content;
  }  
  return (
    <section className="Browsemuseums Termscenter">
      <Container>
        <div className="Browsemuseums-para Termscenter">
          <div
            dangerouslySetInnerHTML={{
              __html: getContent()
                ? getContent()
                :  `<div className="d-flex align-items-center justify-content-center">
                  <p>Loading....</p>
                </div>`,
            }}
          />
        </div>
      </Container>
    </section>
  );
}
